import { OptionList } from '../../ui';
import { useFieldContext } from '../FieldContext';
import { selectOptionsOf } from '../fieldTypeMeta';

/**
 * A checkbox list rather than a multi-select popover: on a phone every option is
 * a 40px row you can hit without aiming, and nothing is hidden behind a second
 * tap. Values are option IDS in metadata order.
 *
 * THE LIST ITSELF IS `ui/OptionList` (`ui-foundation.md` D2). This file used to build one:
 * a `<fieldset>` with a bordered box, a legend carrying the field's label, and a row per
 * option. Two things went with the primitive. The BOX and its LEGEND, because every host
 * of this input already renders the field's label beside it - the record row, the record
 * editor, the approve dialog - so the legend was a second label for the same thing, which
 * is the argument `MultiSelectCellInput` has always made for the cell editor. And the ROW
 * ARRANGEMENT, because three call sites deriving it separately is what put five checkboxes
 * on top of each other in the filter popover on 2026-09-05.
 */
export function MultiSelectInput() {
  const { field, value, onChange, readOnly } = useFieldContext();
  const selected = Array.isArray(value) ? value : [];

  return (
    <OptionList
      ariaLabel={field.label}
      options={selectOptionsOf(field).map((option) => ({
        value: option.id,
        label: option.label,
        tone: option.color ?? 'neutral',
      }))}
      value={selected}
      // Values stay in METADATA ORDER whichever way the user ticks them, which is
      // `OptionList`'s rule now rather than this file's copy of it.
      onChange={(next) => onChange([...next])}
      readOnly={readOnly}
    />
  );
}
